import { apiClient } from '@/lib/apiClient';
import type {
  QueueEntry,
  TeamActionResponse,
  TeamDetail,
  TeamLeave,
  TeamListResponse,
  TeamStatus,
} from '../types';

export interface ListTeamsParams {
  limit?: number;
  cursor?: string;
  status?: TeamStatus;
}

export interface TerminateTeamBody {
  reason: string;
}

export interface FreezeWarnBody {
  reason?: string;
}

export interface RemoveFromQueueBody {
  userId: string;
}

export interface AdminRemoveFromTeamBody {
  targetUserId: string;
  reason: string;
  applyPrerequisite?: boolean;
  penaltyPoints?: number;
}

export interface AdminCreateTeamBody {
  userIdA: string;
  userIdB: string;
}

export const teamsApi = {
  list: (params: ListTeamsParams = {}) =>
    apiClient.get<TeamListResponse>('/teams', { ...params }),

  detail: (teamId: string) =>
    apiClient.get<TeamDetail>(`/teams/${encodeURIComponent(teamId)}`),

  leaves: (teamId: string) =>
    apiClient.get<{ leaves: TeamLeave[] }>(`/teams/${encodeURIComponent(teamId)}/leaves`),

  queue: (limit?: number) =>
    apiClient.get<{ entries: QueueEntry[] }>('/teams/queue', { limit }),

  removeFromQueue: (body: RemoveFromQueueBody) =>
    apiClient.post<TeamActionResponse>('/teams/queue/remove', body),

  adminCreateTeam: (body: AdminCreateTeamBody) =>
    apiClient.post<TeamActionResponse>('/teams/actions/admin-create', body),

  freeze: (teamId: string, body: FreezeWarnBody) =>
    apiClient.post<TeamActionResponse>(
      `/teams/${encodeURIComponent(teamId)}/actions/freeze`,
      body,
    ),

  warn: (teamId: string, body: FreezeWarnBody) =>
    apiClient.post<TeamActionResponse>(
      `/teams/${encodeURIComponent(teamId)}/actions/warn`,
      body,
    ),

  terminate: (teamId: string, body: TerminateTeamBody) =>
    apiClient.post<TeamActionResponse>(
      `/teams/${encodeURIComponent(teamId)}/actions/terminate`,
      body,
    ),

  adminRemoveMember: (teamId: string, body: AdminRemoveFromTeamBody) =>
    apiClient.post<TeamActionResponse>(
      `/teams/${encodeURIComponent(teamId)}/actions/admin-remove`,
      body,
    ),
};
